



































import { getInstance } from '@/services'
import { VaultItem } from 'vaultifier'
import Vue, { PropType } from 'vue'
import List from './List.vue'

export interface Data {
  downstreamIds: number[];
  upstreamIds: number[];
  isWorking: boolean;
}

export default Vue.extend({
  components: {
    List,
  },
  props: {
    item: Object as PropType<VaultItem>,
  },
  data: (): Data => ({
    downstreamIds: [],
    upstreamIds: [],
    isWorking: false,
  }),
  created() {
    this.refreshRelations();
  },
  watch: {
    item() {
      this.refreshRelations();
    },
    downstreamIds() {
      this.emitUpdate();
    },
    upstreamIds() {
      this.emitUpdate();
    },
  },
  methods: {
    async refreshRelations() {
      this.isWorking = true;

      const res = await getInstance().getRelations(this.item.id);
      const relations = res.find(x => x.id === this.item.id);

      this.isWorking = false;

      if (!relations) {
        this.downstreamIds = this.upstreamIds = [];
        return;
      }

      this.downstreamIds = relations.downstream;
      this.upstreamIds = relations.upstream;
    },
    selectId(id: number) {
      this.$emit('selectId', id);
    },
    emitUpdate() {
      this.$emit('update', this.downstreamIds, this.upstreamIds);
    }
  }
})
